import { apiLogin } from "../api.js";
import { navigate } from "../main.js";
import { saveSession } from "../state.js";

const DEFAULT_TENANT = import.meta.env.VITE_DEFAULT_TENANT ?? "skillcontabilidade";

export function renderLogin(root: HTMLElement) {
  root.innerHTML = `
    <div class="center-stage">
      <div class="center-card">
        <h1>Entrar no Questor Zen</h1>
        <p>Use suas credenciais do portal do escritório de contabilidade.</p>

        <form id="form-login" autocomplete="off">
          <label for="username">E-mail</label>
          <input type="email" id="username" name="username" required autofocus />

          <label for="password">Senha</label>
          <input type="password" id="password" name="password" required />

          <label for="tenant">Escritório</label>
          <input type="text" id="tenant" name="tenant" value="${DEFAULT_TENANT}" required />

          <div class="error" id="err" role="alert"></div>

          <div style="margin-top: 18px; display: flex; gap: 10px; align-items: center;">
            <button type="submit" class="btn" id="entrar">Entrar</button>
            <span id="loading" class="subtitle" hidden>Autenticando…</span>
          </div>
        </form>
      </div>
    </div>
  `;

  const form = root.querySelector<HTMLFormElement>("#form-login")!;
  const err = root.querySelector<HTMLDivElement>("#err")!;
  const btn = root.querySelector<HTMLButtonElement>("#entrar")!;
  const loading = root.querySelector<HTMLSpanElement>("#loading")!;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    err.textContent = "";
    btn.disabled = true;
    loading.hidden = false;

    const username = (form.elements.namedItem("username") as HTMLInputElement).value.trim();
    const password = (form.elements.namedItem("password") as HTMLInputElement).value;
    const tenant = (form.elements.namedItem("tenant") as HTMLInputElement).value.trim();

    try {
      const session = await apiLogin(username, password, tenant);
      saveSession(session);
      navigate("start");
    } catch (e) {
      const m = (e as Error).message || "Credenciais inválidas ou acesso não autorizado";
      err.textContent = m;
    } finally {
      btn.disabled = false;
      loading.hidden = true;
    }
  });
}
